export const STANDARD = 'standard';
export const RARE = 'rare';
